export default "__VITE_ASSET__HccFQ4Xa__"